module.exports = __webpack_public_path__ + "assets/img/e8fb93f39a57f5bc1865f89c8f0a9a21.svg";